import { useApiMutation } from '@/hooks/use-api-query';

// No qk.org(orgId, ...) cache read holds the org object itself yet — the org
// identity/profile read lives in org-layout's unconverted fetch state and is
// refreshed via refreshOrg() after a save — so there is nothing to invalidate
// here. Add invalidation when the org-layout read converts to Query (Batch E).

interface UpdateOrgNameVars {
  name: string;
}

interface UpdateOrgProfileVars {
  email: string;
  phone: string;
  website: string;
  businessCategory: string;
  businessNiche: string;
  primaryUseCase: string;
}

/** PATCH /organizations/:orgId — org rename (org-admin only). */
export function useUpdateOrgName(orgId: string | undefined) {
  return useApiMutation<void, UpdateOrgNameVars>((vars) => ({
    path: `/organizations/${orgId}`,
    init: {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(vars),
    },
    fallback: 'Failed to update organization',
  }));
}

/** PATCH /organizations/:orgId/profile — org profile fields (org-admin only). */
export function useUpdateOrgProfile(orgId: string | undefined) {
  return useApiMutation<void, UpdateOrgProfileVars>((vars) => ({
    path: `/organizations/${orgId}/profile`,
    init: {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(vars),
    },
    fallback: 'Failed to update organization',
  }));
}
